export enum JiraFieldType {
  any = 'any',
  string = 'string',
  number = 'number',
  option = 'option',
  array = 'array',
  user = 'user',
  project = 'project',
  date = 'date',
  dateTime = 'datetime',
  issueType = 'issuetype',
  optionWithChild = 'option-with-child',
  component = 'component',
  version = 'version',
  priority = 'priority',
  labels = 'labels',
  group = 'group',
  team = 'team',
}

export enum JiraArrayType {
  component = 'component',
  option = 'option',
  string = 'string',
  version = 'version',
  user = 'user',
}

export enum JiraSchemaCustomType {
  textArea = 'com.atlassian.jira.plugin.system.customfieldtypes:textarea',
  radioButtons = 'com.atlassian.jira.plugin.system.customfieldtypes:radiobuttons',
  url = 'com.atlassian.jira.plugin.system.customfieldtypes:url',
  labels = 'com.atlassian.jira.plugin.system.customfieldtypes:labels',
}

export enum JiraFieldNameType {
  reporter = 'Reporter',
}
